export enum BeneficiaryType {
  Legal = 'LEGAL',
  Partner = 'PARTNER',
  Child = 'CHILD',
  Parents = 'PARENTS',
  Testamentary = 'TESTAMENTARY',
  Individual = 'INDIVIDUAL',
  Policyholder = 'POLICYHOLDER',
}
